// extracted by mini-css-extract-plugin
export default {"addressSection":"rT-z","disabled":"sT-z","sectionButtons":"tT-z","logo":"uT-z"};